module.exports = __webpack_public_path__ + "img/reward_600.de948f76.png";